import defaultCountry from './defaultCountry';

export function preAssessmentSmeFlow(options) {
  const countryFlow = defaultCountry;
  return typeof countryFlow === 'function' ? countryFlow(options) : countryFlow;
}
